<template>
	<div>
		<div
			class="modal fade"
			id="importScrapperData"
			tabindex="-1"
			role="dialog"
			aria-labelledby="openModal"
			aria-hidden="true"
			data-backdrop="static"
		>
			<div class="modal-dialog modal-lg" role="document">
				<div
					class="modal-content campaign-g-addedit"
					style="width:1000px;height:auto;margin-left:-49px"
				>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Add Data To Asin-Scraper In Bulk</h5>
						<button type="button" class="close" data-dismiss="modal" @click= "getList">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="margin-top:25px;margin-left:40px;width:85%">
						<div class = "form-group row">
							<div v-if = "isFileUploading" class="spinner-border" style="padding-left: 16px;"></div>
							<div class = "" v-else>
								<div class = "form-group row">
									<div class = "col-md-6" v-if = "(!isDataSyncing && !fileUploadedName)">
										<a style = "display:flex;align-items:center;" href="sampleBulkUploadAsin.csv" id="file_download_asins" download>Download Sample Asin CSV</a>
									</div>
									<div class = "col-md-12" v-else>
									    <a style = "display:flex;align-items:center;" href="sampleBulkUploadAsin.csv" id="file_download_asins" download>Download Sample Asin CSV</a>
									</div>
									<div class = "col-md-6" v-if = "(!isDataSyncing && !fileUploadedName)">
										<input
											class="choose"
											type="file"
											placeholder="Import Data From csv"
											multiple="false"
											accept=".csv"
											@change="uploadFile"
										>
									</div>
									<div v-else></div>
								</div>
							</div>
							<div v-if = "fileUploadedName" class = "col-md-3" style = "display:flex;align-items:top">
								<p>{{fileUploadedName}}</p>
							</div>
							<div v-if = "isDataSyncing && fileUploadedName" class = "col-md-3">
								<span class="spinner-border" ></span>
								<span>....Data is syncing</span>
							</div>
							<div class = "col-md-10 pt-5" v-if="!isDataSyncing && isDataUploded && isDataUploded == 'Following list of Asins are not added ...'">
								<p style = "color:red;white-space:norwrap;">{{isDataUploded}}</p>
							</div>
							<div class = "col-md-10 pt-5" v-else-if="isDataUploded && !isDataSyncing">
								<p style = "color:rgb(39, 196, 117)">{{isDataUploded}}</p>
							</div>
							<div class = "pt-5" v-if ="!isDataSyncing && isDataUploded == 'Following list of Asins are not added ...'" style="padding-left:0px;margin-left:0px">
								<!-- <button  @click = "createFile">Download Asin</button> -->
								<a style = "" @click = "createFile" href ="javascript:void(0)">Download Asins</a>
							</div>
						</div>
					</div>

					<div class="modal-footer">
						<div class="mt-2" style="text-align: center">
							<button type="button" class="btn btn-primary" data-dismiss="modal" @click = "getList">Done</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import XLSX from "xlsx";
	export default {
		name: "ImportFilePopUp",
		components: {
		},
		mounted() {
			//this.openCampaignGroup();
		},
		data() {
			return {
				isFileUploading:false,
				fileUploadedName:"",
				isDataSyncing:false,
				isDataUploded:"",
				notAddedAsin: []
			};
		},
		watch: {},
		methods: {
			getList(){
				this.fileUploadedName = "";
				this.isDataSyncing = false;
				this.isFileUploading = false;
				this.isDataUploded = '';
				this.$emit("closePopUp")
			},
			uploadFile(evt){
				let file = evt.target.file || evt.target.files[0];
				let vm = this;

				this.isFileUploading = true;
				this.$store.dispatch("asinScapper/getPresighnedURL").then((res) => {
					let data = {
						url : res.uploadUrl,
						data: file
					}
					vm.$store.dispatch("asinScapper/uploadFile", data).then(response => {
						vm.isFileUploading = false;
						vm.fileUploadedName = file.name
						let payload = {
							uploadUrl: res.uploadUrl,
							downloadUrl: res.downloadUrl,
							name: file.name
						}
						vm.isDataSyncing = true;
						vm.$store.dispatch("asinScapper/updateFileData", payload).then((data) => {
							vm.isDataSyncing = false;
							if(data && data.length){
								this.notAddedAsin = data;
								vm.isDataUploded = 'Following list of Asins are not added ...'
								console.log(vm.isDataUploded);
							}
							else{
								vm.isDataUploded = 'File has been imported successfully. It may take some time to reflect changes in list page.'
							}
						})
					})
				})

		},
		s2ab(s) {
			var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
			var view = new Uint8Array(buf);  //create uint8array as viewer
			for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
			return buf;
		},
		createFile(){
			console.log(this.notAddedAsin.length)
			let vm = this;
			if(this.notAddedAsin.length){
				let data = this.notAddedAsin.map((res) => {
					let obj  = {};
					obj.asin = res.asin;
					obj.cause = res.cause;
					obj['Vendor Name'] = res.vendorname;
					obj['Country'] = res.country_code
					// obj['Abbreviated Title'] = res.abbrev_title
					return obj;
				})


				const wb = XLSX.utils.book_new();
				var workbook = XLSX.utils.json_to_sheet(data);

				XLSX.utils.book_append_sheet(
					wb,
					workbook,
					"asins.csv"
				);


				let safariAgent = navigator.userAgent.indexOf("Safari") > -1;
				let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1;

				if(safariAgent && !chromeAgent){
					var wbout = XLSX.write(wb, {bookType:'csv',  type: 'binary'});
					var blob = new Blob([vm.s2ab(wbout)], { type: 'application/octet-stream"' });
					var link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = "asins-file.csv";
					link.target = "_blank";
					link.click();
				}
				else{
					// var wbout = XLSX.write(wb, {bookType:'csv',  type: 'binary'});
					// var blob = new Blob([vm.s2ab(wbout)], { type: 'text/csv;charset=utf-8;'  });
					// let url = window.URL.createObjectURL(blob);
					// let w =  window.open(url, '_blank');
					// w.focus()
					var wbout = XLSX.write(wb, {bookType:'csv',  type: 'binary'},'FailedAsin.csv');
					var blob = new Blob([vm.s2ab(wbout)], { type: 'application/octet-stream"' });
					var link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = "asins-file.csv";
					link.target = "_blank";
					link.click();
				}

			}


				//w.document.execCommand('SaveAs', true, 'asin.txt')
		}
	}
}
</script>
<style lang="scss">
</style>
